import * as Types from '../../../../../../../../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConversationButtonCallbackMutationVariables = Types.Exact<{
  conversationId: Types.Scalars['ID'];
  buttonId: Types.Scalars['ID'];
}>;


export type ConversationButtonCallbackMutation = { __typename?: 'Mutation', ConversationButtonCallback: { __typename?: 'GenericResponse', ok?: boolean | null } };


export const ConversationButtonCallbackDocument = gql`
    mutation ConversationButtonCallback($conversationId: ID!, $buttonId: ID!) {
  ConversationButtonCallback(conversationId: $conversationId, buttonId: $buttonId) {
    ok
  }
}
    `;
export type ConversationButtonCallbackMutationFn = ApolloReactCommon.MutationFunction<ConversationButtonCallbackMutation, ConversationButtonCallbackMutationVariables>;

/**
 * __useConversationButtonCallbackMutation__
 *
 * To run a mutation, you first call `useConversationButtonCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConversationButtonCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [conversationButtonCallbackMutation, { data, loading, error }] = useConversationButtonCallbackMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      buttonId: // value for 'buttonId'
 *   },
 * });
 */
export function useConversationButtonCallbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConversationButtonCallbackMutation, ConversationButtonCallbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConversationButtonCallbackMutation, ConversationButtonCallbackMutationVariables>(ConversationButtonCallbackDocument, options);
      }
export type ConversationButtonCallbackMutationHookResult = ReturnType<typeof useConversationButtonCallbackMutation>;
export type ConversationButtonCallbackMutationResult = ApolloReactCommon.MutationResult<ConversationButtonCallbackMutation>;
export type ConversationButtonCallbackMutationOptions = ApolloReactCommon.BaseMutationOptions<ConversationButtonCallbackMutation, ConversationButtonCallbackMutationVariables>;